import {
    bufferToggle,
    filter,
    map,
    mergeMap,
    mergeWith,
    Observable,
    share,
    tap,
    windowToggle,
    withLatestFrom
} from 'rxjs'

export function pauseable<T, P>(pauser: Observable<P>, pausePredicate: ((value: P, index: number) => boolean)) {
    return function(source: Observable<T>): Observable<T> {
        const on$ = pauser.pipe(filter((v, i) => !pausePredicate(v, i)))
        const off$ = pauser.pipe(filter(pausePredicate))
        const openWindow$ = source.pipe(windowToggle(on$, () => off$), mergeMap(x => x))
        const buffer$ = source.pipe(bufferToggle(off$, () => on$), mergeMap(x => x))
        return openWindow$.pipe(mergeWith(buffer$))
    }
}

export function takeIf<T, P>(other: Observable<P>, takePredicate: ((value: P) => boolean)) {
    return function(source: Observable<T>): Observable<T> {
        return source.pipe(
            share(),
            withLatestFrom(other),
            filter(([_, v]) => takePredicate(v)),
            map(([x, _]) => x)
        )
    }
}
